import React, { useEffect, useState } from 'react';
import CustomTabPanel from './customTabPanel';
import { AmountInvoiceList } from './amountInvoice';
import { CreditInvoiceList } from './creditInvoice';
import { CampaignInvoiceList } from './campaignInvoice';

export const InvoiceList = () => {
  const [selectedPanelStatus, setSelectedPanelStatus] = useState('Amount');
  const [load, setLoad] = useState(true);

  return (
    <>
      <CustomTabPanel setSelectedPanelStatus={setSelectedPanelStatus} setLoad={setLoad} />

      {selectedPanelStatus === 'Amount' && <AmountInvoiceList load={load} setLoad={setLoad} />}
      {selectedPanelStatus === 'Credit' && <CreditInvoiceList load={load} setLoad={setLoad} />}
      {selectedPanelStatus === 'Campaign' && <CampaignInvoiceList load={load} setLoad={setLoad} />}
    </>
  );
};
